import React from 'react';
import QuarterlyAwardSummaryCard from './components/QuarterlyAwardSummaryIndex.jsx';

const QuarterlyAwardSummary = () => <QuarterlyAwardSummaryCard />;

export default QuarterlyAwardSummary;
